import { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { I18n } from '@/i18n/I18n';
import { LoadingSpinner } from '../LoadingSpinner';
import { ConfirmModal } from '../modals/ConfirmModal';

export function NeutralDeleteButton(props: { onSubmit: () => Promise<unknown>, itemType: string, title: string, disabled?: boolean, processing?: boolean, warningText?: string }) {
  const { onSubmit, itemType, title, disabled, processing } = props;
  const modelDetails = { model: I18n.get(itemType), title };
  const confirmMessage = title ? I18n.get('areYouSure', modelDetails) : I18n.get('areYouSureNoTitle', modelDetails);
  const [show, setShow] = useState(false);

  const handleSubmission = async () => {
    setShow(false);
    await onSubmit();
  };

  return (
    <>
      <button
        type="button"
        className="fusa-btn-small-with-icon btn-neutral-light"
        onClick={() => setShow(true)}
        aria-label={I18n.get('deleteModel', modelDetails)}
        title={I18n.get('deleteModel', modelDetails)}
        disabled={disabled}
      >
        { processing ? <LoadingSpinner /> : <Trash2 size={16} /> }
      </button>

      {show && (
        <ConfirmModal
          confirmMessage={confirmMessage}
          onConfirm={() => handleSubmission()}
          setShowModal={setShow}
          confirmText={I18n.get('delete')}
        />
      )}
    </>
  );
}